import $i18n from 'panda-i18n';
import React, { useContext, useEffect, useRef } from 'react';
import { CardItemsStateCtx } from '../../context/card-items';
import './index.scss';
export const LoadMore = () => {
    const loadMoreDomRef = useRef(null);
    const { dataSource, loading, hasNextPage, loadNextPage } = useContext(CardItemsStateCtx);
    useEffect(() => {
        const dom = loadMoreDomRef.current;
        if (loading || !hasNextPage || !dom)
            return;
        const io = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio <= 0)
                return;
            loadNextPage();
        }, { threshold: 1 });
        io.observe(dom);
        return () => {
            io.unobserve(dom);
            io.disconnect();
        };
    }, [loadNextPage, loading, hasNextPage]);
    if (!dataSource.length)
        return null;
    if (loading) {
        return (React.createElement("div", { className: "cn-ui-m-card-items-more-loading" }, $i18n.get({ id: 'Loading', dm: '加载中', ns: 'CnCardItems' })));
    }
    if (hasNextPage) {
        return (React.createElement("div", { ref: loadMoreDomRef, className: "cn-ui-m-card-items-load-more" }, $i18n.get({
            id: 'PullDownToLoadMore',
            dm: '下拉加载更多',
            ns: 'CnCardItems',
        })));
    }
    return (React.createElement("div", { className: "cn-ui-m-card-items-no-more" }, $i18n.get({ id: 'NoMore', dm: '没有更多了', ns: 'CnCardItems' })));
};
